import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import BookingFlow from '../components/BookingFlow';

const BookingHero = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.85)), url("/images/booking-hero.png")',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '50vh',
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.common.white,
  [theme.breakpoints.down('md')]: {
    height: '40vh',
  },
}));

const BookingPage = () => {
  return (
    <Box>
      <BookingHero>
        <Container sx={{ position: 'relative', zIndex: 1 }}>
          <Typography 
            variant="h2" 
            component="h1" 
            gutterBottom
            sx={{
              fontWeight: 700,
              fontSize: { xs: '2.5rem', md: '3.75rem' },
              textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
              mb: 3,
              background: 'linear-gradient(90deg, #FFFFFF 0%, rgba(255,255,255,0.9) 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Book Your Journey
          </Typography>
          <Typography 
            variant="h5"
            sx={{
              maxWidth: '600px',
              textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
              fontSize: { xs: '1.1rem', md: '1.5rem' },
              fontWeight: 400,
              opacity: 0.95,
              lineHeight: 1.5,
              letterSpacing: '0.5px',
            }}
          >
            Experience luxury travel with our premium chauffeur service. Your comfort and satisfaction are our top priorities.
          </Typography>
        </Container>
      </BookingHero>

      <Container sx={{ py: 4 }}>
        <Paper 
          elevation={3}
          sx={{
            p: 4,
            backgroundColor: 'background.paper',
            borderRadius: 2,
            mt: -8,
            position: 'relative',
            zIndex: 2,
          }}
        >
          <BookingFlow />
        </Paper>
      </Container>
    </Box>
  );
};

export default BookingPage; 